<template>
  <div>
    <!--顶部工具条-->
    <el-col :span="24">
      <el-form :inline="true">
        <el-form-item label="">
          <el-input
            style="width: 180px"
            v-model="filters.keyWord"
            placeholder="请输入促销活动名称"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item style="margin-left: 20px">
          <toolbar
            :buttonList="buttonList"
            @callFunction="callFunction"
          ></toolbar>
        </el-form-item>
      </el-form>
    </el-col>
    <!--列表-->
    <el-table
      :data="tableData"
      highlight-current-row
      v-loading="listLoading"
      style="width: 100%"
      border
      @current-change="selectCurrentRow"
      class="custom-padding-table"
    >
      <el-table-column
        prop="name"
        label="促销活动名称"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="productType"
        label="产品类型"
        align="center"
        show-overflow-tooltip
      >
        <template #default="scope">
          <span v-if="scope.row.productType == 0">所有产品</span>
          <span v-if="scope.row.productType == 1">所有单品</span>
          <span v-if="scope.row.productType == 2">所有合集</span>
          <span v-if="scope.row.productType == 3">部分产品</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="numberName"
        label="产品形式"
        align="center"
        show-overflow-tooltip
      >
        <template #default="scope">
          <span v-if="scope.row.productForm == -1">暂不显示</span>
          <span v-if="scope.row.productForm == 0">所有形式</span>
          <span v-if="scope.row.productForm == 1">视频</span>
          <span v-if="scope.row.productForm == 2">文档</span>
        </template></el-table-column
      > -->
      <el-table-column
        prop="totalOtherPromotionCount"
        label="促销类型"
        align="center"
        show-overflow-tooltip
      >
        <template #default="scope">
          <el-tag type="success" v-if="scope.row.discountType == 1">折扣</el-tag>
          <el-tag type="danger" v-if="scope.row.discountType == 2">优惠券</el-tag>
          <el-tag type="danger" v-if="scope.row.discountType == 3">满减</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="discountDescription"
        label="促销规则"
        align="center"
        show-overflow-tooltip
      >
        <template #default="scope">
          <span v-if="scope.row.discountType == 1"
            >{{ scope.row.discountRatio*100 }}%</span
          >
          <span v-if="scope.row.discountType == 3"
            >满{{ scope.row.discountBasic }}减{{
              scope.row.discountValue
            }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="startTime"
        label="活动开始时间"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="endTime"
        label="活动结束时间"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="isEnable"
        label="是否启用"
        align="center"
        show-overflow-tooltip
      >
        <template #default="scope">
          <el-tag type="info"  v-if="scope.row.isEnable == 0">禁用</el-tag>
          <el-tag type="success" v-if="scope.row.isEnable == 1">启用</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="updateUserName"
        label="修改人"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column fixed="right" label="操作" width="" align="center">
        <template slot-scope="scope">
          <el-button
            @click="enableBtnFun(scope.row)"
            type="text"
            size="small"
            >{{ scope.row.isEnable == 1 ? "禁用" : "启用" }}</el-button
          >
          <el-button
            type="text"
            size="small"
            @click="jumpPromotionSettingDetail(scope.row)"
            >修改记录</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--底部工具条-->
    <el-col :span="24" class="pageBar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages.pageIndex"
        :page-sizes="pages.pageArr"
        :page-size="pages.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pages.dataCount"
      >
      </el-pagination>
    </el-col>

    <!--订单新增区域新增界面-->
    <el-dialog
      :title="editmark == true ? '编辑' : '新增'"
      :visible.sync="FormVisible"
      v-model="FormVisible"
      :close-on-click-modal="false"
    >
      <div style="display: flex">
        <div class="left" style="flex: 1">
          <el-form
            :model="Form"
            label-width="100px"
            ref="Form"
            style="max-width: 700px"
            :rules="FormRules"
          >
            <el-form-item label="活动名称：" prop="name">
              <el-input
                v-model="Form.name"
                auto-complete="off"
                placeholder="请输入标题"
              ></el-input>
            </el-form-item>

            <el-form-item label="活动范围: " prop="range">
              <el-select
                style="width: 120px"
                clearable
                v-model="Form.range"
                placeholder="请选择"
                @change="handleRangeChange"
              >
                <el-option
                  v-for="item in rangeOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-select
                style="width: 190px; margin-left: 5px"
                multiple
                collapse-tags
                clearable
                v-model="Form.productIds"
                placeholder="请选择具体产品"
                v-if="Form.range == 3"
              >
                <el-option
                  v-for="item in productOptions"
                  :key="item.id"
                  :label="item.headline"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="优惠类型">
              <el-radio-group
                v-model="Form.discountType"
                @change="handlediscountTypeChange"
              >
                <el-radio :label="3">满减</el-radio>
                <el-radio :label="1">折扣</el-radio>
              </el-radio-group>
            </el-form-item>
            <div v-if="Form.discountType == 3" style="display: flex">
              <el-form-item label="优惠力度：" prop="discountBasic" class="no-left">
                <span>每满&nbsp;</span>
                <el-input
                  v-model="Form.discountBasic"
                  auto-complete="off"
                  placeholder=""
                  style="width: 80px"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="" prop="discountValue"  class="no-margin-form-item no-left" >
                <span>&nbsp;元减&nbsp;</span>

                <el-input
                  v-model="Form.discountValue"
                  auto-complete="off"
                  placeholder=""
                  style="width: 80px;"
                  clearable
                ></el-input>
                <span>&nbsp;元</span>
              </el-form-item>
            </div>

            <el-form-item
              label="优惠力度："
              prop="discountRatio"
              v-if="Form.discountType == 1"
            >
              <el-input
                v-model="Form.discountRatio"
                auto-complete="off"
                placeholder=""
                style="width: 100px"
              ></el-input>
              %(例80%)
            </el-form-item>

            <el-form-item label="活动时间:" prop="serachTimer">
              <el-date-picker
                v-model="Form.serachTimer"
                :unlink-panels="true"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="是否启用：">
              <el-radio-group v-model="Form.isEnable">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="FormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="FormSubmit"
          :loading="listLoading"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import util from "../../../util/date";
import {
  getPromotionSettingsListApi,
  addPromotionSettingsApi,
  editPromotionSettingsApi,
  updatePromotionStatus,
  getProductListPage,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import Qs from "qs";
export default {
  components: { Toolbar },
  data() {
    return {
      util: "",
      tableData: [],
      listLoading: false,
      //增删改查按钮
      buttonList: [],
      //顶部筛选条件
      filters: {
        keyWord: "",
      },

      //关于分页的obj
      pages: {
        pageSize: 20, //默认每页条数
        pageArr: [10, 20, 30, 40], //默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },

      rangeOptions: [
        {
          id: 0,
          name: "所有商品",
        },
        {
          id: 1,
          name: "所有单品",
        },
        {
          id: 2,
          name: "所有合集",
        },
        {
          id: 3,
          name: "部分产品",
        },
      ],
      productOptions: [],
      pid: 0,
      FormVisible: false,
      Form: {
        name: "",
        range: "",
        productIds: "",
        discountType: 3,
        discountBasic: null,
        discountValue: null,
        discountRatio: null,
        serachTimer: "",
        isEnable: 1,
      },

      FormRules: {
        name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        range: [{ required: true, message: "请选择活动范围", trigger: "blur" }],
        // 👇 新增以下三条规则
        discountBasic: [
          { required: true, message: "请输入‘每满’金额", trigger: "blur" },
        ],
        discountValue: [
          { required: true, message: "请输入‘减’金额", trigger: "blur" },
        ],
        discountRatio: [
          { required: true, message: "请输入折扣力度", trigger: "blur" },
        ],
        serachTimer: [
          { required: true, message: "请选择活动时间", trigger: "blur" },
        ],
      },
      currentRow: "",
      editmark: false,
    };
  },
  methods: {
     // 【新增】查询按钮调用的方法
    handleSearch() {
      this.pages.pageIndex = 1;
      this.getList();
    },
    jumpPromotionSettingDetail(row) {
      this.$router.push({
        path: "/PromotionSettingDetail",
        query: {
          id: row.id,
        },
      });
    },
    enableBtnFun(row) {
      console.log("row", row);
      let isEnable = row.isEnable == 1 ? 0 : 1;
      let params = {
        id: row.id,
        isEnable: isEnable,
      };
      updatePromotionStatus(params).then((res) => {
        if (res.data.success) {
          this.$message.success(res.data.message);
          this.getList();
        }
      });
    },
    getList() {
      var params = {
        ...this.filters,
        pageIndex: this.pages.pageIndex,
        pageSize: this.pages.pageSize,
      };
      getPromotionSettingsListApi(params).then((res) => {
        this.tableData = res.data.response.data;
        this.pages.dataCount = res.data.response.dataCount;
      });
    },
    getProductList() {
      getProductListPage().then((res) => {
        if (res.data.success) {
          this.productOptions = res.data.response.data;
          console.log("this.productOptions", this.productOptions);
        }
      });
    },

    selectCurrentRow(row) {
      this.currentRow = row;
    },

    async handleEdit() {
      if (!this.currentRow) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      // 等待 DOM 渲染完成再调用 resetFields
      this.$nextTick(() => {
        if (this.$refs.Form) {
          this.$refs.Form.resetFields();
        }
      });
      this.editmark = true;

      // 【关键修改】将字符串 ID 转换为数字数组
      let rawIds = this.currentRow.productIds || "";
      let idArray = [];

      if (rawIds && rawIds.trim() !== "") {
        idArray = rawIds
          .split(",")
          .map((id) => Number(id)) // 转为数字
          .filter((id) => !isNaN(id)); // 过滤无效值
      }
      // 深拷贝一下
      this.Form = {
        id: this.currentRow.id,
        name: this.currentRow.name,
        range: this.currentRow.productType,
        productIds: idArray,
        discountType: this.currentRow.discountType,
        discountBasic: this.currentRow.discountBasic,
        discountValue: this.currentRow.discountValue,
        discountRatio: this.currentRow.discountRatio*100,
        serachTimer: [this.currentRow.startTime, this.currentRow.endTime],
        isEnable: this.currentRow.isEnable,
      };

      // let searchTimer = [this.currentRow.startTime, this.currentRow.endTime];
      // // 通过$set强制触发响应式
      // this.$set(this.Form, "serachTimer", searchTimer);
      this.FormVisible = true;
    },
    handleAdd() {
      // 等待 DOM 渲染完成再调用 resetFields
      this.$nextTick(() => {
        if (this.$refs.Form) {
          this.$refs.Form.resetFields();
        }
      });
      this.editmark = false;
      (this.Form = {
        name: "",
        range: "",
        productIds: "",
        discountType: 3,
        discountBasic: null,
        discountValue: null,
        discountRatio: null,
        serachTimer: "",
        isEnable: 1,
      }),
        (this.FormVisible = true);
    },

    //提交新增表单
    FormSubmit() {
      this.$refs.Form.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.listLoading = true;
            if (this.Form.discountType == 1) {
              this.Form.discountBasic = null;
              this.Form.discountValue = null;
            }
            if (this.Form.discountType == 3) {
              this.Form.discountRatio = null;
            }
            const { serachTimer, productIds,discountRatio, ...restForm } = this.Form;

            console.log("productIds", productIds);

            let params = {
              ...restForm,
              discountRatio:discountRatio + '%',
              // 如果 productIds 是数组，则 join；如果是空或字符串，则保持原样或直接转字符串
              productIds: Array.isArray(productIds)
                ? productIds.join(",")
                : productIds || "",
              startTime: this.Form.serachTimer
                ? this.formatCreateTime(this.Form.serachTimer[0])
                : "",
              endTime: this.Form.serachTimer
                ? this.formatCreateTime(this.Form.serachTimer[1])
                : "",
            };

            console.log("params", params);

            if (this.editmark) {
              editPromotionSettingsApi(params).then((res) => {
                if (res.data.success) {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.$refs["Form"].resetFields();
                  this.FormVisible = false;
                  this.getList();
                } else {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "error",
                  });
                }
              });
            } else {
              addPromotionSettingsApi(params).then((res) => {
                if (res.data.success) {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.$refs["Form"].resetFields();
                  this.FormVisible = false;
                  this.handleSearch();
                } else {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "error",
                  });
                }
              });
            }
          });
        }
      });
    },

    handleRangeChange(val) {
      console.log("val", val);
    },
    handlediscountTypeChange() {
      if (this.currentRow.discountType == 3) {
        this.Form.discountRatio = null;
      }
      if (this.currentRow.discountType == 1) {
        this.Form.discountBasic = null;
        this.Form.discountValue = null;
      }
    },

    formatCreateTime: function (date) {
      return !date || date == ""
        ? ""
        : util.formatDate.format(new Date(date), "yyyy-MM-dd hh:mm:ss");
    },

    // apply改变this指向
    callFunction(item) {
      this[item.func].apply(this, item);
    },
    // 分页
    handleCurrentChange(val) {
      this.pages.pageIndex = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.getList();
    },
  },
  mounted() {
    this.getList();
    this.getProductList();
    this.util = util;
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>
<style lang="stylus" scoped>
.rolesTop {
  width: 100%;
  display: flex;
}

.rolesInp {
  width: 300px;
  margin-right: 20px;
}

.pageBar {
  margin-top: 15px;
}


/* 👇👇👇 新增的样式开始 👇👇👇 */
.custom-padding-table
  ::v-deep .el-table__cell
    /* 上下内边距，根据需要调整数值，默认通常是 8px 或 10px */
    padding-top: 16px
    padding-bottom: 16px
    
  /* 如果上面的写法在某些构建环境下不生效，可以尝试加 !important 强制覆盖 */
  ::v-deep td.el-table__cell
    padding-top: 16px !important
    padding-bottom: 16px !important
/* 👆👆👆 新增的样式结束 👆👆👆 */

.no-margin-form-item
  ::v-deep .el-form-item__content
    margin-left: 0px !important


.no-left
  ::v-deep .el-form-item__content .el-form-item__error
    left:30px !important;
    width:110px !important;
</style>
